import base from './base.repository';

export default {
    ...base,
    getPaged(page = 1, filters){
        const params = {...filters, page};
        this.get(`positions${this.querify(params)}`);
        return this;
    },
    getAll(){
        this.get('positions/all');
        return this;
    },
    savePosition(payload){
        this.post('positions', payload);
        return this;
    },
    deletePosition(positionId){
        this.delete(`positions/${positionId}`);
        return this;
    }
}